import React from 'react';
import { Row, Col, Card, Table, Progress, Space, Typography } from 'antd';
import { TrophyOutlined } from '@ant-design/icons';
import StatsCard from '../../components/shared/StatsCard';
import { mockExerciseTypeStats, mockDifficultyDistribution, mockMuscleGroupData } from '../data/mockData';

const { Text } = Typography;

const ExercisesTab: React.FC = () => {
  const muscleGroupColumns = [
    {
      title: 'Muscle Group',
      dataIndex: 'muscle',
      key: 'muscle',
      render: (text: string) => <Text strong>{text}</Text>,
    },
    {
      title: 'Exercises',
      dataIndex: 'exercises',
      key: 'exercises',
      sorter: (a: any, b: any) => a.exercises - b.exercises,
    },
    {
      title: 'Coverage',
      dataIndex: 'coverage',
      key: 'coverage',
      render: (coverage: number) => (
        <Space>
          <Progress 
            percent={coverage} 
            size="small" 
            showInfo={false}
            strokeColor={coverage >= 90 ? '#52c41a' : coverage >= 70 ? '#faad14' : '#f5222d'}
          />
          <Text>{coverage}%</Text>
        </Space>
      ),
      sorter: (a: any, b: any) => a.coverage - b.coverage,
    },
  ];

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} lg={12}>
        <StatsCard
          title="Exercise Types"
          icon={<TrophyOutlined />}
          stats={mockExerciseTypeStats}
        />
      </Col>
      <Col xs={24} lg={12}>
        <StatsCard
          title="Difficulty Distribution"
          progress={mockDifficultyDistribution}
        />
      </Col>
      <Col span={24}>
        <Card title="Muscle Group Analysis" size="small">
          <Table
            dataSource={mockMuscleGroupData}
            columns={muscleGroupColumns}
            pagination={false}
            size="small"
            rowKey="muscle"
          />
        </Card>
      </Col>
    </Row>
  );
};

export default ExercisesTab; 